// The review task adopts the existing Romantic display-name maximum (waiting-pool-entry.v1.ts), not its identity data.
export const FRIENDSHIP_NICKNAME_MAX = 40;
export function nicknameValue(raw: unknown): string {
 if (typeof raw !== "string" || !raw.trim() || /[\u0000-\u001f\u007f]/u.test(raw)) throw new Error("请填写 Friendship 昵称");
 if (Array.from(raw).length > FRIENDSHIP_NICKNAME_MAX) throw new Error(`Friendship 昵称最多 ${FRIENDSHIP_NICKNAME_MAX} 个字`);
 return raw.trim();
}
